import { useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const mockMessages = [
  {
    from: "concierge",
    text: "Welcome to Sartaj. How may I assist you with our premium basmati collection today?",
  },
];

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState(mockMessages);
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg = { from: "user", text: input };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");

    // Mock concierge reply
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          from: "concierge",
          text: "Thank you for your interest. Our team will connect with you shortly. In the meantime, explore our premium collection above.",
        },
      ]);
    }, 1200);
  };

  return (
    <div className="fixed bottom-20 right-6 z-50" data-testid="chat-widget">
      {/* Chat Window */}
      {isOpen && (
        <Card
          data-testid="chat-window"
          className="absolute bottom-16 right-0 w-80 sm:w-96 border border-brand-gold/20 bg-brand-primary shadow-2xl rounded-none overflow-hidden"
        >
          <CardHeader className="p-4 border-b border-brand-gold/20 flex flex-row items-center justify-between space-y-0">
            <div>
              <CardTitle className="font-heading text-lg text-brand-gold font-light">
                Sartaj Concierge
              </CardTitle>
              <p className="text-[10px] uppercase tracking-widest text-brand-text-light/50 font-body">
                Online
              </p>
            </div>
            <button
              data-testid="chat-close-btn"
              onClick={() => setIsOpen(false)}
              className="text-brand-text-light/50 hover:text-brand-gold transition-colors"
            >
              <X size={16} />
            </button>
          </CardHeader>

          <CardContent className="p-0">
            {/* Messages */}
            <div className="h-64 overflow-y-auto p-4 space-y-3">
              {messages.map((msg, i) => (
                <div
                  key={i}
                  className={`flex ${msg.from === "user" ? "justify-end" : "justify-start"}`}
                >
                  <div
                    className={`max-w-[80%] px-4 py-2.5 text-xs font-body leading-relaxed ${
                      msg.from === "user"
                        ? "bg-brand-gold text-brand-primary"
                        : "bg-brand-bg-dark border border-brand-gold/10 text-brand-text-light/80"
                    }`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="border-t border-brand-gold/20 p-3 flex gap-2">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                placeholder="Type a message..."
                data-testid="chat-input"
                className="flex-1 bg-transparent text-xs text-brand-text-light placeholder:text-brand-text-light/30 font-body focus:outline-none"
              />
              <button
                data-testid="chat-send-btn"
                onClick={handleSend}
                className="text-brand-gold hover:text-brand-gold-light transition-colors"
              >
                <Send size={16} />
              </button>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Floating Button */}
      <button
        data-testid="chat-widget-button"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 flex items-center justify-center shadow-xl transition-all duration-300 ${
          isOpen
            ? "bg-brand-gold text-brand-primary rotate-0"
            : "bg-brand-primary text-brand-gold chat-bounce border border-brand-gold/30"
        }`}
      >
        {isOpen ? <X size={22} /> : <MessageCircle size={22} />}
      </button>
    </div>
  );
};

export default ChatWidget;
